// Shared "Read More"/"Read Less" toggle initializer for search overview
let overviewToggleBound = false;

export function initReadMoreToggle() {
  if (overviewToggleBound) return;
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('streaming-toggle')) return;
    const button = e.target;
    const container = button.closest('#search-overview') || button.closest('#benchmate_chats');
    if (!container) return;
    const content =
      container.querySelector('[data-target="content"]') ||
      container.querySelector('.streaming-response') ||
      container.querySelector('.ai-overview-body');
    if (!content) return;
    e.preventDefault();
    const expanded = content.classList.toggle('full-mode');
    button.textContent = expanded ? 'Read less ↑' : 'Read more ↓';
  });
  overviewToggleBound = true;
}